(function () {
  'use strict';

  var section = document.querySelector('.main-contact');
  var submittedFields = section && section.querySelector('.main-contact__form-fields.is-submitted');
  var successState = section && section.querySelector('.main-contact__success-state');

  if (!section || !submittedFields || !successState) return;

  var normalContent = section.querySelector('.main-contact__normal');
  section.classList.add('is-submitted');

  requestAnimationFrame(function () {
    if (normalContent) normalContent.setAttribute('aria-hidden', 'true');
    successState.setAttribute('aria-hidden', 'false');
    section.classList.add('is-transitioning');

    window.setTimeout(function () {
      window.location.replace('/');
    }, 3000);
  });
})();
